import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { EventStatus } from "../../event-page-models/event-status";
import { eventPageUtils } from "../../utils/event-page-utils";
import { getEnumNumbers } from "../../../../_helpers/enum-utils";

import { EventsService } from "../../../../_services/eventsServices/events.service";
import { EventEditor } from "../../event-page-models/event-editor";
import { DataService } from "../../../../_services/data.service";
import { AuthenticationService } from "../../../../_services/authentication.service";

@Component({
  selector: "create-parent-event-user-permission-row",
  templateUrl: "./create-parent-event-user-permission-row.component.html",
  styleUrls: ["./create-parent-event-user-permission-row.component.scss"],
})
export class CreateParentEventUserPermissionRow implements OnInit, OnDestroy {
  @Output("changeUserStatus") public rowEvent: EventEmitter<EventEditor> =
    new EventEmitter<EventEditor>();
  @Input() public eventEditor: EventEditor;

  constructor(
    private eventService: EventsService,
    private dataService: DataService,
    private authenticationService: AuthenticationService
  ) {}

  public static buildStatusOptions() {
    return getEnumNumbers(EventStatus).map((n) => ({
      text: eventPageUtils.eventStatusToText(n),
      value: n,
    }));
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  public formatDate(date: Date) {
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  }

  public changeStatus($event: any) {
    this.rowEvent.emit(this.eventEditor);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/create-parent-event-page-form-users-permissions/create-parent-event-page-user-permission-row/create-parent-event-user-permission-row.component.ts